import {
  changeCurrency,
  selectCurrency,
  selectCurrencyData,
} from 'legacy/lut/features/partner360/configuration'
import { selectAvailableCurrencies } from 'legacy/lut/features/partner360/configuration/selectors/selectAvailableCurrencies'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

export const useCurrencies = () => {
  /** -------------------- Variables ----------------------- */
  const dispatch = useAppDispatch()
  const availableCurrencies = useSelector(selectAvailableCurrencies)
  const activeCurrency = useSelector(selectCurrency)
  const { localCurrency } = useSelector(selectCurrencyData)

  /** -------------------- Methods ----------------------- */
  const setCurrency = useCallback(
    (newCurrency: string) => {
      dispatch(changeCurrency(newCurrency))
    },
    [dispatch]
  )

  return {
    localCurrency,
    activeCurrency,
    availableCurrencies,
    setCurrency,
  }
}
